import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Geolocation, Coordinates } from '@awesome-cordova-plugins/geolocation/ngx';
import { NativeGeocoder } from '@awesome-cordova-plugins/native-geocoder/ngx';
import { Platform } from '@ionic/angular';
import { catchError, map, Observable, BehaviorSubject } from 'rxjs';
import { ContentType, RemoteRequest } from 'src/remote-request';
import { RemoteHttpService } from 'src/remote-http';
import { Custom_RequestMethod } from 'services/common-service';
/*
 Generated class for the GeolocationService provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class GeolocationService {
  private lastLocation: Coordinates;

  constructor(
    platform: Platform,
    private geolocation: Geolocation,
    private http: HttpClient
    // public http: RemoteHttpService,
    // public requestMethod: Custom_RequestMethod
  ) {
    platform.ready().then(() => {
      // console.debug('geo location [00]', this.geolocation);
      if (this.geolocation) {
        this.geolocation.getCurrentPosition().then(
          pos => {
            console.debug('geo location [0]', pos);
            this.lastLocation = pos.coords;
          },
          err => {}
        );

        this.geolocation
          .watchPosition()
          .pipe()
          .subscribe(
            (pos: any) => {
              // console.debug('geo location [1]', pos);
              this.lastLocation = pos.coords;
              this.getCountryFromCoordinates(pos?.coords?.latitude, pos?.coords?.longitude);
            },
            err => {}
          );
      }
      if (1) {
        this.getCurrentPosition().subscribe(location => {
          // console.debug('geo location [2]', location);
          this.lastLocation = location.coords;
          this.getCountryFromCoordinates(location?.coords?.latitude, location?.coords?.longitude);
        });
      }
    });
  }
  public getLatitude(): number {
    if (this.lastLocation) return this.lastLocation.latitude;
    else return null;
  }

  public getLongitude(): number {
    if (this.lastLocation) return this.lastLocation.longitude;
    else return null;
  }

  getCurrentPosition(): Observable<GeolocationPosition> {
    return new Observable(observer => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          position => {
            observer.next(position);
            observer.complete();
          },
          error => observer.error(error)
        );
      } else {
        observer.error('Geolocation is not available in this browser.');
      }
    });
  }

  private apiKey = 'AIzaSyBIWGFvJ3l50LN1WM-7-D6-PZYHzdm0nF8';

  /**
   * Stop the geolocation watch
   */
  public stop() {
    // if(isPresent(this.watch) && !this.watch.isUnsubscribed)
    //     this.watch.unsubscribe();
  }

  // Get device location
  getNewCurrentPosition(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject('Geolocation not supported by browser');
      } else {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      }
    });
  }

  // Reverse geocoding to get country
  async getCountryFromCoordinates(lat: number, lng: number): Promise<string> {
    // console.debug('geo get country from coords', lat, lng);

    // this._getCountryFromCoordinates(lat, lng, this.apiKey).subscribe(result => {
    //   console.debug('geo result from service : ', result);
    // });
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${this.apiKey}`;

    try {
      // const res: any = await this._getCountryFromCoordinates(lat, lng, this.apiKey);
      const res: any = await this.http.get(url).toPromise();
      // console.debug('geo get country from coords [0]', lat, lng);
      if (res.status === 'OK') {
        // Loop through results to find country
        for (const result of res.results) {
          for (const type of result.types) {
            if (type === 'country') {
              // return result.formatted_address;
              this.setGeoLocation({
                latitude: lat,
                longitude: lng,
                countryId: result.address_components[0].short_name,
                countryName: result.address_components[0].long_name,
              });
              return result.address_components[0].short_name;
            }
          }
        }
      }
      return 'Unknown';
    } catch (err) {
      console.error('Geocoding error', err);
      return 'Unknown';
    }
  }

  geoLocation: BehaviorSubject<any> = new BehaviorSubject({
    latitude: null,
    longitude: null,
    countryId: '',
    countryName: '',
  });

  setGeoLocation(geoLocation) {
    this.geoLocation.next(geoLocation);
  }

  getGeoLocation() {
    return this.geoLocation.asObservable();
  }

  // private _getCountryFromCoordinates(lat: number, long: number, apiKey: string) {
  //   let _url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${apiKey}`;

  //   let request = new RemoteRequest(
  //     _url,
  //     this.requestMethod.get,
  //     ContentType.URL_ENCODED_FORM_DATA
  //   );
  //   return this.http
  //     .execute(request, undefined, this.getLatitude(), this.getLongitude())
  //     .pipe(
  //       map((resp: any) => {
  //         console.debug('geo coords service : ', resp);
  //         let coords: any = resp;

  //         return coords;
  //       })
  //     )
  //     .pipe(catchError(this.http.handleError));
  // }
}
